var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeslice-player",style:({width: _vm.width, height: _vm.height})},[_c('time-slice',{ref:"timeslice",attrs:{"timeslice-inicialization-data":_vm.timesliceRecorging.initData,"should-record":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }